import { invoiceTypeEnumList } from '../../../components/AgGrid/enumLists'

const invoiceTypeValueGetter = (props) => {
  const { value } = props
  return invoiceTypeEnumList(value)
}

export default invoiceTypeValueGetter
